import React from "react";

function WhyUs(props) {
  return (
    <section id="why-us" class="why-us">
      <div class="container">
        <div class="row">
          <div class="col-lg-4" data-aos="fade-up">
            <div class="box">
              <span>01</span>
              <h4>Custom Solutions</h4>
              <p>
                We develop accounting systems for the individual request of your
                business and then maintain the system according to user desires.
                Trust us in every decision.
              </p>
            </div>
          </div>

          <div
            class="col-lg-4 mt-4 mt-lg-0"
            data-aos="fade-up"
            data-aos-delay="150"
          >
            <div class="box">
              <span>02</span>
              <h4>Website & Mobile APP Solutions</h4>
              <p>
                Black Box Software Solutions’ well-experienced developers are
                here to deliver an excellent website & Mobile App development
                service. Our services are available in Afghanistan, and anywhere
                else around the Globe.
              </p>
            </div>
          </div>

          <div
            class="col-lg-4 mt-4 mt-lg-0"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div class="box">
              <span>03</span>
              <h4>E-Business Solutions</h4>
              <p>
                Our Ecommerce Platform must also fully support the requirements
                of your business. Accounting, marketing, customer service, and
                other vital functions are absolutely necessary for the
                maintenance and continued growth of your business.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
